import { React, useEffect, useState } from 'react';
import './Device.css';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

const Device = ({
  url,
  company,
  image,
  type,
  name,
  website_name,
  properties,
  isNew,
  short_description,
  compareList,
  setCompareList,
}) => {

  const propertiesArray = properties ? properties.split(',') : null;
  const [isPopupVisible, setPopupVisible] = useState(false);

  const handleOnChange = (event) => {
    if (event.target.checked) {
      if (compareList.length >= 4) {
        setPopupVisible(true); // Show popup
      } else {
        // Add `name`, `website_name`, and `image` to the compareList
        setCompareList((prev) => [...prev, { name, website_name, image }]);
      }
    } else {
      // Remove the item by `name`
      setCompareList((prev) =>
        prev.filter((item) => item.name !== name)
      );
    }
  };

  const handleClose = () => setPopupVisible(false);

  return (
    <div className="device">
      <div
        className={`device-container ${
          compareList && compareList.some((item) => item.name === name)
            ? 'is-check'
            : ''
        }`}
      >
        <div className="device-header">
          <div className="device-compare">
            <input
              type="checkbox"
              id={`compare-checkbox-${name}`}
              checked={compareList && compareList.some((item) => item.name === name)}
              onChange={handleOnChange}
            />
            <label htmlFor={`compare-checkbox-${name}`}>Compare</label>
          </div>
          {
            company ? (
              <img src={url + '/' + company} />
            ) : (
              <div></div>
            )
          }
          
        </div>
        <div className="device-image">
          {
            image ? (
              <img className="device-img" src={url + '/' + image} />
            ) : (
              <img className='' src={require("../../assets/Images/no-image.png")} />
            )
          }
          
        </div>
        <div className="device-footer">
          <div></div>
          {isNew && <div className="new-device">New</div>}
        </div>
      </div>
      <div className="device-content">
        <div className="device-type">{type}</div>
        <div className="device-name"> {website_name} </div>
        <div className="device-properties">
          {propertiesArray &&
            propertiesArray.map((property, index) => (
              <div key={index}>{property.trim()}</div>
            ))}
        </div>
      </div>

      <Modal
        open={isPopupVisible}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="popup-container">
          You can only compare up to <span>4</span> devices at a time.
        </Box>
      </Modal>
    </div>
  );
};

export default Device;
